import { render, staticRenderFns } from "./ProjectReportsParentBar.component.vue?vue&type=template&id=b3540104&scoped=true"
import script from "./ProjectReportsParentBar.component.vue?vue&type=script&lang=js"
export * from "./ProjectReportsParentBar.component.vue?vue&type=script&lang=js"
import style0 from "./ProjectReportsParentBar.component.vue?vue&type=style&index=0&id=b3540104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3540104",
  null
  
)

export default component.exports